import React from 'react';
import { Flex, useMediaQuery } from '@chakra-ui/react';
import { Wrapper } from './ImagesRowStyled';
import { MyProjectFragment } from '@src/generated/graphql';
import SanityImage from '@components/Shared/SanityImage';

const ImagesRow: React.FC<Pick<MyProjectFragment, 'imagesRow'>> = ({
  imagesRow,
}) => {
  const [isMobile] = useMediaQuery('(max-width: 767px)');
  if (!imagesRow) return null;
  const imageProps = isMobile
    ? { width: 768, height: 1121 }
    : { width: 328, height: 479 };
  return (
    <Wrapper>
      <Flex
        justify="space-between"
        gap={5}
        direction={['column', null, 'row']}
        maxW="100%"
      >
        {imagesRow.map((image) => (
          <SanityImage key={image?.alt} sanityImage={image} {...imageProps} />
        ))}
      </Flex>
    </Wrapper>
  );
};

export default ImagesRow;
